<script>
	module.exports = {
		props: {
			contents: {
				default: []
			},
			onLinkClick: {
				default: null
			}
		},

		methods: {
			onHeaderClick(e) {
				if (e && e.currentTarget) {
					let activeDropdown = e.currentTarget.parentElement;
					let dropdownContainer = activeDropdown.parentElement;
					let dropdownList = dropdownContainer.querySelectorAll('.dropdown');
					let isActive = false;
					dropdownList.forEach(dd => {
						if (dd.classList.contains('active')) {
							dd.classList.remove('active');
							if (dd === activeDropdown) {
								isActive = true;
							}
						}
					});
					if (isActive === false) {
						activeDropdown.classList.add('active');
					}
					if (this.onLinkClick) {
						e.preventDefault();
						e.stopImmediatePropagation();

						this.onLinkClick(e.target);
					}
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.teacher-guide-table-of-contents {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		border: 1px solid #cfcfcf;
		z-index: 5;
		position: relative;
		background-color: white;
		font-family: 'Helvetica Neue';
		height: auto;
		font-color: black;
		top: 0px;
		position: sticky;

		.vertical-line {
			border-left: 5px solid white;
			height: 56px;
			margin-left: 0px;
			margin-right: 17px;
		}

		.plus {
			position: relative;
			width: 20px;
			height: 20px;
			margin-top: 17px;
			margin-right: 10px;

			&:before {
				content: '';
				position: absolute;
				background: black;
				left: 50%;
				top: 4px;
				bottom: 4px;
				width: 2px;
				transform: translateX(-50%);
			}

			&:after {
				content: '';
				position: absolute;
				background: black;
				top: 50%;
				left: 4px;
				right: 4px;
				height: 2px;
				transform: translateY(-50%);
			}
		}

		.dropdown.active > .header-container > .plus:before {
			transform: rotate(90deg);
		}

		a {
			color: black;
			font-family: 'Helvetica Neue';
		}

		.dropdown {
			position: relative;
			display: flex;
			float: none;
			font-color: black;
			cursor: pointer;
			flex-direction: column;

			& > input[type='checkbox'] {
				position: absolute;
				display: none;
			}

			& > ul {
				position: relative;
				display: none;
				padding: 6px 0;
				margin: 0;
				list-style: none;
				width: 100%;
				font-size: 15px;
				background-color: white;
				font-color: #5f5f5f;
			}

			& > .header-container {
				display: flex;

				a {
					color: black;
					padding-top: 14px;
					display: flex;
					flex: 1000;
				}
			}

			.vertical-line {
				border-left: 5px solid $c-white;
				margin-left: 0px;
				margin-right: 17px;
				display: flex;
				flex: 1;
			}

			a[role='button'] {
				display: inline-block;
				color: black;
				line-height: 1.5em;
				text-decoration: none;
				cursor: pointer;
				width: 100%;
				min-width: 14rem;

				&:hover {
					background-color: #eeeeee;
				}
			}

			&:hover {
				background-color: #eeeeee;

				.vertical-line {
					border-left: 5px solid $c-blue;
					margin-left: 0px;
					margin-right: 17px;
					display: flex;
					flex: 1;
				}

				.header-container {
					background-color: #eeeeee;
				}
			}

			&.active {
				& > .header-container {
					color: black;
					background-color: #eeeeee;

					.vertical-line {
						border-left: 5px solid $c-blue;
						margin-left: 0px;
						margin-right: 17px;
						display: flex;
						flex: 1;
					}
				}

				& > ul {
					display: block;
					padding-left: 50px;
					font-size: 15px;
					width: 100%;
					max-width: 100%;
					color: #5f5f5f;

					& > li {
						& > a {
							&:hover {
								color: #059fc5;
							}
						}
					}
				}
			}
		}
	}
</style>
<template>
	<div class="teacher-guide-table-of-contents dropdown-format sticky">
		<div
			v-for="item in contents"
			:key="item.label"
			class="dropdown">
			<div
				class="header-container"
				@click.prevent.stop="onHeaderClick">
				<div class="vertical-line"></div>
				<a
					:href="item.href"
					aria-controls="my-dropdown1"
					role="button"
					data-toggle="dropdown">
					{{ item.label }}
				</a>
				<i
					v-if="item.navItems && item.navItems.length"
					class="plus"
					aria-hidden="true"></i>
			</div>
			<ul>
				<li
					v-for="item2 in item.navItems"
					:key="item2.label">
					<a
						@click.prevent.stop="onLinkClick($event.target)"
						:href="item2.href"
						>{{ item2.label }}</a
					>
				</li>
			</ul>
		</div>
	</div>
</template>
